import { i18n } from '../../i18n.config';
import en from './en.json';
import ru from './ru.json';

i18n.addResourceBundle('en', 'lottery', en, true);
i18n.addResourceBundle('ru', 'lottery', ru, true);
